import { action, observable } from 'mobx'

import Store from '../shared/store'
import { apiStore } from '../shared/api'
import { apiClient } from '../shared/api-impl'

import { message as config } from '../config'

import Message from './model'

@apiStore(apiClient)
class MessageStore extends Store {

  @observable loading = false

  @observable collection = []

  constructor(opts = {}) {

    super(opts)

    this.Model = Message

    this.initAPIStore({
      ...opts,
      api: config.api,
    })

  }

  load(...args) {
    return this.api.load(...args)
  }

  save(...args) {
    return this.api.save(...args)
  }

  destroy(...args) {
    return this.api.destroy(...args)
  }

  @action
  send(messageData) {
    return this.create(messageData)
  }

  @action
  loadRegarding(type, id) {
    const opts = {
      action: 'regarding',
      type,
      id
    }
    return this.load(null, opts)
  }

  whereRegarding(type, id) {
    return this.collection.filter((message) =>
      // type seems to be lowercase always, so transform it here
      message.mention && message.mention[type.toLowerCase()] === id)
  }

}

export const messageStore = new MessageStore()



// WEBPACK FOOTER //
// ./src/message/store.js